import { useAppDispatch, useAppSelector } from '../redux/hook';

import { clear } from '../redux/slices/documentSlice';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DocumentUploadTabs = ({ selectedButtonRef, setSelectedButton }) => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const handleClick = (val) => {
		console.log('Clicked');
		dispatch(clear());
		setSelectedButton(val);
	};

	return (
		<>
			<style>
				{`
					.nav-pills .nav-link {
						color: gray;
						background-color: white;
					}

					.nav-pills .nav-link:hover {
						color: gray;
						background-color: white;
					}

					.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
						color: white;
						background-color: #03355C;
					}
				`}
			</style>
			<ul className="nav nav-pills nav-justified px-3">
				{selectedButtonRef?.current === 0 ? (
					<>
						<li
							className="nav-item"
							style={{
								cursor: 'pointer',
							}}>
							<a
								className="nav-link active shadow-sm theme-active"
								onClick={() => handleClick(0)}>
								{t('DocuScanPagePrimaryTab')}
							</a>
						</li>
						<li
							className="nav-item shadow-sm"
							style={{
								cursor: 'pointer',
							}}>
							<a className="nav-link" onClick={() => handleClick(1)}>
								{t('DocuScanPageSecondaryTab')}
							</a>
						</li>
					</>
				) : (
					<>
						<li
							className="nav-item shadow-sm"
							style={{
								cursor: 'pointer',
							}}>
							<a
								className="nav-link"
								onClick={() => handleClick(0)}
								style={{
									cursor: 'pointer',
								}}>
								{t('DocuScanPagePrimaryTab')}
							</a>
						</li>
						<li
							className="nav-item"
							style={{
								cursor: 'pointer',
							}}>
							<a
								className="nav-link active  theme-active"
								onClick={() => handleClick(1)}>
								{t('DocuScanPageSecondaryTab')}
							</a>
						</li>
					</>
				)}
			</ul>
		</>
	);
};

export default DocumentUploadTabs;
